import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from "mobx-react";
import * as React from "react";
import { EventPromoLine } from "@faire/retailer/components/Events/shared/EventPromoLine";
var MarketPromoLineBase = function(param) {
    var promotion = param.promotion;
    return /*#__PURE__*/ _jsx(EventPromoLine, {
        text: promotion,
        fullWidth: true,
        mediumText: true
    });
};
export var MarketPromoLine = observer(MarketPromoLineBase);
